import store from '@/store/store'

class IntentModule {

  getIntent = () => store.state.intent

  getIntents = () => store.state.intents

  setIntent(intent) {
    store.commit('INTENT_SET', intent)
  }

  setIntents(intents) {
    store.commit('INTENTS_SET', intents)
  }
}

export default new IntentModule()
